import PropTypes from 'prop-types';
import React from 'react';
import {
  Chip,
  Container,
  Divider,
  FormControlLabel,
  FormLabel,
  Stack,
  Typography,
  RadioGroup,
  Radio,
  FormControl,
  TextField,
  Box,
  Button,
  useMediaQuery
} from '@mui/material';
import { useParams } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import _ from 'lodash';
import arrowBackFilled from '@iconify/icons-eva/arrow-back-fill';
import plusCircleFill from '@iconify/icons-eva/plus-circle-fill';
import questionMarkCircleFill from '@iconify/icons-eva/question-mark-circle-fill';
import trash2Outline from '@iconify/icons-eva/trash-2-outline';
import arrowCircleUpOutline from '@iconify/icons-eva/arrow-circle-up-outline';
import arrowCircleDownOutline from '@iconify/icons-eva/arrow-circle-down-outline';
import edit2Outline from '@iconify/icons-eva/edit-2-outline';
import personOutline from '@iconify/icons-eva/person-outline';
import menu2Outline from '@iconify/icons-eva/menu-2-outline';
import { Icon } from '@iconify/react';
import { v4 as uuidv4 } from 'uuid';
import { LoadingButton } from '@mui/lab';
import { useTheme } from '@mui/material/styles';
import moment from 'moment-timezone';
//
import Page from '../components/Page';
import Header from '../components/_landingpage/LandingHeader';
import * as uatServices from '../services/uat';
import useWidth from '../hooks/useWidth';
import SaveSuccessPage from './SaveSuccessPage';

const UATResponder = ({ user, type }) => {
  const { id, idresponse } = useParams();
  const [uat, setUat] = React.useState({});
  const theme = useTheme();
  const width = useWidth(useTheme, useMediaQuery);
  const [answers, setAnswers] = React.useState([]); // meta: id_question, status, comment
  const [pemeriksa, setPemeriksa] = React.useState('');
  const [errors, setErrors] = React.useState({});
  const [saved, setIsSaved] = React.useState(false);

  const saveAnswer = (item, index, value, type) => {
    try {
      const data = [...answers];
      data[index] = {
        ...data[index],
        id_question: item.id,
        [type]: value
      };

      setAnswers(data);
    } catch (error) {
      toast.error(error.message);
    }
  };

  const getUAT = async () => {
    try {
      if (!id) return toast.error('Maaf, gagal mendapatkan ID UAT');
      const body = {
        id,
        role: user?.attributes?.role
      };
      const result = await uatServices.getByID(body);
      setUat(result.data);
    } catch (error) {
      toast.error(error.message);
    }
  };

  const saveAnswers = () => {
    try {
      let counter = 0;
      const errorCollector = {};
      const questionsLength = uat?.meta?.questions.length;
      answers.forEach((item, index) => {
        if (item.status) {
          errorCollector[index] = true;
          counter += 1;
        }
        if (!item.status) errorCollector[index] = true;
      });

      setErrors(errorCollector);

      if (counter !== questionsLength)
        return toast.error(`Harap isi semua pertanyaan ${questionsLength}, ${counter}`);

      if (!pemeriksa) return toast.error('Nama pemeriksa belum diisi');

      const newID = uuidv4();
      let body = {};

      const prevAnswers = Array.isArray(uat.meta.answers) ? uat.meta.answers : [];
      prevAnswers.push({
        meta: answers,
        id: newID,
        attributes: { creator: pemeriksa, createdAt: moment.tz('Asia/Jakarta').format() }
      });

      const newAnswers = prevAnswers;

      body = {
        data: {
          id: uat.id,
          meta: {
            ...uat.meta,
            answers: newAnswers
          }
        }
      };

      toast
        .promise(uatServices.updateForm(body), {
          loading: 'Menyimpan data ...',
          error: <b>Maaf, terjadi kesalahan</b>,
          success: <b>Data berhasil disimpan</b>
        })
        .then(() => {
          setIsSaved(true);
        });
    } catch (error) {
      toast.error(error.message);
    }
  };

  React.useEffect(() => getUAT(), []);

  const updateAnswers = () => {
    if (_.isEmpty(uat?.meta?.answers)) return;

    const data = uat.meta.answers.filter((item) => item.id === idresponse);

    const sourceAnswers = data[0].meta;
    const sourceQuestions = uat.meta.questions;

    const sortedAnswers = [];

    sourceQuestions.forEach((item) => {
      const answer = sourceAnswers.filter((i) => i.id_question === item.id);
      sortedAnswers.push(answer[0]);
    });

    setAnswers(sortedAnswers);
    setPemeriksa(data[0]?.attributes?.creator);
  };

  React.useEffect(() => {
    if (type === 'response') updateAnswers();
  }, [uat]);
  return (
    <Page title="UAT Responder | Peladen Pemda DIY">
      <Header user={user} />
      <Container maxWidth="md" sx={{ paddingBottom: 2 }}>
        {saved ? (
          <SaveSuccessPage />
        ) : (
          <Stack direction="column" spacing={2}>
            <Typography variant="h6">Formulir UAT</Typography>
            <Typography variant="body1">{uat?.attributes?.title}</Typography>
            <Typography variant="body1">{uat?.attributes?.description}</Typography>
            <Divider />
            {!_.isEmpty(uat?.meta?.questions) &&
              uat.meta.questions.map((item, index) => (
                <Stack direction="row" spacing={2}>
                  <Stack sx={{ flex: 0.2 }}>
                    <Typography variant="body1">{index + 1}.</Typography>
                  </Stack>
                  <Stack direction="column" spacing={2} sx={{ flex: 11.8 }}>
                    <Typography variant="body1">{item?.attributes?.label}</Typography>
                    <Stack direction="row" spacing={1}>
                      {uat?.meta?.complements?.menu
                        .map((itemCM) => itemCM?.attributes?.name)
                        .includes(item?.attributes?.menu?.label) && (
                        <Chip
                          icon={
                            <Icon
                              icon={menu2Outline}
                              width={24}
                              height={24}
                              style={{ color: theme.palette.primary.main }}
                            />
                          }
                          variant="outlined"
                          label={item?.attributes?.menu?.label}
                        />
                      )}

                      {!_.isEmpty(item?.attributes?.roles) &&
                        item?.attributes?.roles.map(
                          (itemRole) =>
                            itemRole.label &&
                            itemRole.checked &&
                            uat?.meta?.complements?.roles
                              ?.map((itemCM) => itemCM.attributes?.name)
                              .includes(itemRole.label) && (
                              <Chip
                                icon={
                                  <Icon
                                    icon={personOutline}
                                    width={24}
                                    height={24}
                                    style={{ color: theme.palette.info.main }}
                                  />
                                }
                                variant="outlined"
                                label={itemRole.label}
                              />
                            )
                        )}
                    </Stack>
                    <FormControl>
                      <FormLabel>Hasil Tes</FormLabel>
                      <RadioGroup
                        sx={{ flexDirection: 'row' }}
                        aria-labelledby="Hasil Tes"
                        name="status"
                        value={(answers && answers[index]?.status) || null}
                        onChange={(event) => {
                          if (type !== 'response')
                            saveAnswer(item, index, event.target.value, 'status');
                        }}
                      >
                        <FormControlLabel value="accept" control={<Radio />} label="Berhasil" />
                        <FormControlLabel
                          value="reject"
                          control={<Radio />}
                          label="Tidak Berhasil"
                        />
                      </RadioGroup>
                    </FormControl>
                    <Stack direction="row">
                      <TextField
                        disabled={type === 'response'}
                        onChange={(e) => {
                          if (type !== 'response')
                            saveAnswer(item, index, e.target.value, 'comment');
                        }}
                        value={answers[index]?.comment}
                        multiline
                        fullWidth
                        label="Catatan"
                        placeholder="Dapat diisi dengan catatan pengujian"
                      />
                    </Stack>
                  </Stack>
                </Stack>
              ))}
            <Divider />

            <Stack direction="column" spacing={2}>
              <Box>
                <TextField
                  disabled={type === 'response'}
                  sx={{ width: ['xs', 'sm'].includes(width) ? '100%' : '50%' }}
                  label="Nama Pemeriksa"
                  placeholder="Dapat diisi nama pribadi/Instansi"
                  value={pemeriksa}
                  onChange={(e) => setPemeriksa(e.target.value)}
                />
              </Box>
              {type === 'answer' && (
                <Button variant="contained" onClick={() => saveAnswers()}>
                  Simpan Formulir
                </Button>
              )}
            </Stack>
          </Stack>
        )}
      </Container>
    </Page>
  );
};

UATResponder.propTypes = {
  user: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired
};

export default UATResponder;
